<template>
    <div class="row">
        <div class="col-xs-3">
            <FormInputMasked v-model="postal_code" label="CEP" type="tel" :required="true" mask="#####-###" @blur="getAddress" tooltip="Informe o código postal do endereço" ref="postal_code" />
        </div>
        <div class="col-xs-9">
            <FormInput v-model="street" label="Logradouro" type="text" :required="true" @blur="updateMap" tooltip="Informe o logradouro do endereço" ref="street" />
        </div>
        <div class="col-xs-3">
            <FormInput v-model="number" label="Número" type="tel" :required="false" @blur="updateMap" tooltip="Informe o número do endereço" ref="number" />
        </div>
        <div class="col-xs-3">
            <FormInput v-model="complement" label="Complemento" type="text" :required="false" tooltip="Informe o complemento do endereço" ref="complement" />
        </div>
        <div class="col-xs-6">
            <FormInput v-model="neighborhood" label="Bairro" type="text" :required="false" @blur="updateMap" tooltip="Informe o bairro do endereço" ref="neighborhood" />
        </div>
        <div class="col-xs-10">
            <FormInput v-model="city" label="Cidade" type="text" :required="true" @blur="updateMap" tooltip="Informe a cidade do endereço" ref="city" />
        </div>
        <div class="col-xs-2">
            <FormSelect v-model="uf" label="UF" :options="options.uf" :required="true" @blur="updateMap" tooltip="Informe a Unidade Federativa do endereço" ref="uf" />
        </div>
        <div class="col-xs-12">
            <p class="google-maps-label">Posição <span v-popover:tooltip.right="'Posicione o marcador no local correto do endereço, o mais preciso possível'"><i class="fas fa-question-circle"></i></span></p>
            <form-google-maps class="map google-maps-form"
                :center="center"
                :zoom="zoom"
                :infoMarker="marker"
                @updateAddressByMarker='updateAddressByMarker'
                ref="map"></form-google-maps>
        </div>
    </div>
</template>

<script>
import Api from "@/lib/Api";

import FormInput from "@/components/FormInput";
import FormInputMasked from "@/components/FormInputMasked";
import FormSelect from "@/components/FormSelect";
import FormGoogleMaps from "@/components/FormGoogleMaps";

import $ from "jquery";

export default {
	name: "FormGroupAddress",

	props: [
        "current_id",
        "current_postal_code",
        "current_street",
        "current_number",
        "current_complement",
        "current_neighborhood",
        "current_city",
        "current_uf",
        "current_country",
        "current_coordinates"
    ],

	components: {
        FormInput,
        FormInputMasked,
        FormSelect,
        FormGoogleMaps,
    },

	data: function() {
        return {
            id: this.current_id,
            postal_code: this.current_postal_code,
            street: this.current_street,
            number: this.current_number,
            complement: this.current_complement,
            neighborhood: this.current_neighborhood,
            city: this.current_city,
            uf: this.current_uf,
            country: this.current_country,
            coordinates: this.current_coordinates,

            options: this.getOptions(),
            
            zoom: this.coordinates ? 15 : 3,
            center: this.coordinates ? {
                lat: this.current.coordinates.split(",")[0],
                lng: this.current.coordinates.split(",")[1],
            } : {
                lat: -18.145851771694314,
                lng: -53.7890625,
            },
            
            marker: null,
        }
	},

    watch: {
        current_id: function(value) {
            this.id = value;
        },

        current_postal_code: function(value) {
            this.postal_code = value;
            this.$refs.postal_code.update(value);
        },
        
        current_street: function(value) {
            this.street = value;
            this.$refs.street.update(value);
        },
        
        current_number: function(value) {
            this.number = value;
            this.$refs.number.update(value);
        },
        
        current_complement: function(value) {
            this.complement = value;
            this.$refs.complement.update(value);
        },

        current_neighborhood: function(value) {
            this.neighborhood = value;
            this.$refs.neighborhood.update(value);
        },
        
        current_city: function(value) {
            this.city = value;
            this.$refs.city.update(value);
        },
        
        current_uf: function(value) {
            this.uf = value;
            this.$refs.uf.select(value);
        },

        current_coordinates: function(value) {
            if (value != null) {
                this.coordinates = value;
                this.updateMap();
            } else {
                this.coordinates = null;
                this.cleanMap();
            }
        },
    },

    mounted: function() {
        if (this.id) {
            this.setInfoMap();
        }
    },

	methods: {
        getOptions: function() {
            return {
                uf: {
                    'AC': 'AC',
                    'AL': 'AL',
                    'AP': 'AP',
                    'AM': 'AM',
                    'BA': 'BA',
                    'CE': 'CE',
                    'DF': 'DF',
                    'ES': 'ES',
                    'GO': 'GO',
                    'MA': 'MA',
                    'MT': 'MT',
                    'MS': 'MS',
                    'MG': 'MG',
                    'PA': 'PA',
                    'PB': 'PB',
                    'PR': 'PR',
                    'PE': 'PE',
                    'PI': 'PI',
                    'RJ': 'RJ',
                    'RN': 'RN',
                    'RS': 'RS',
                    'RO': 'RO',
                    'RR': 'RR',
                    'SC': 'SC',
                    'SP': 'SP',
                    'SE': 'SE',
                    'TO': 'TO'
                }
            };
        },

        // Formata o endereço
        getAddressFormatted: function() {
            let addressFormatted = '';

            if (this.street) addressFormatted += this.street.toLowerCase();
            if (this.number) addressFormatted += ', ' + this.number;
            if (this.neighborhood) addressFormatted += ' - ' + this.neighborhood.toLowerCase();
            if (this.city) addressFormatted += ', ' + this.city.toLowerCase();
            if (this.uf) addressFormatted += ' - ' + this.uf.toUpperCase();
            if (this.postal_code) addressFormatted += ', ' + this.postal_code;
            if (this.country) addressFormatted += ', ' + this.country.toLowerCase();

            return addressFormatted;
        },

        // Retorna messagem de erro no campo determinado
        message: function(input) {
            return "'" + input + "' deve ser preenchido.";
        },

        // Verifica e valida inicialmente os campos
		validation: function() {
            let data = {
                id: '',
                postal_code: '',
                street: '',
                number: '',
                complement: '',
                neighborhood: '',
                city: '',
                uf: '',
                country: '',
                coordinates: null,
            };
            let error = false;
            
            // Id 
            data.id = this.id;
			
            // CEP
			if (this.postal_code == "") {
                this.$refs.postal_code.validate();
				this.$notification.error(this.message("CEP"));
                error = true;
			} else {
				data.postal_code = this.postal_code;
			}
			
            // Endereço
			if (this.street == "") {
                this.$refs.street.validate();
				this.$notification.error(this.message("LOGRADOURO"));
                error = true;
			} else {
				data.street = this.street;
			}
			
            // Número
            data.number = this.number;
            
            // Complemento
			data.complement = this.complement;
            
            // Bairro
			data.neighborhood = this.neighborhood;
			
            // Cidade
			if (this.city == "") {
                this.$refs.city.validate();
                this.$notification.error(this.message("CIDADE"));
                error = true;
			} else {
				data.city = this.city;
			}

            // UF
			if (this.uf == "") {
                this.$refs.uf.trigger_blur();
                this.$notification.error(this.message("UF"));
                error = true;
			} else {
				data.uf = this.uf;
            }
            
            // Pasís
            data.country = this.country;

            // Coordenadas
            data.coordinates = this.coordinates;
            
            // Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return data;
            }
        },
        
        // Requisita o endereço
        getAddress: async function() {
            let result = {};
            
            // Verifica o CEP
            if(this.postal_code.length == 9) {
                // Requisita as informações de endereço
                $.ajax({
                    url: 'https://viacep.com.br/ws/' + this.postal_code + '/json/',
                    type: 'get',
                    dataType: 'json',
                    async: false,
                    success: function(response) {
                        result = response;
                    },
                    error: function(response) {
                        result = response;
                    }
                });

                // Verifica se houve resultado
                if(!result.erro) {
                    // Se houver preenche os campos
                    this.updateAddressByForm(result);
                    await this.updateMap();
                } else {
                    // Se não houver exibe o erro
                    this.$notification.error("Não foi possível obter as informações de endereço automaticamente.");
                    this.cleanForm();
                    this.cleanMap();
                }
            }
        },

        // Preenche os campos
        updateAddressByForm: function(result) {
            this.$refs.street.update(result.logradouro);
            this.$refs.number.update("");
            this.$refs.complement.update("");
            this.$refs.neighborhood.update(result.bairro);
            this.$refs.city.update(result.localidade);
            this.$refs.uf.clear_selected();
            this.$refs.uf.select(result.uf);
        },

        // Requisita a API as coordenadas
        getAddressCoordinates: async function() {
            // Solicita a validação
			let address = {
                street: this.street,
                number: this.number,
                complement: this.complement,
                neighborhood: this.neighborhood,
                city: this.city,
                uf: this.uf,
                country: this.country,
                postal_code: this.postal_code,
            };
            
            // Requisita o salvamento
			this.loading = true;
            let result = null;
            let path = this.$api.user.sysadmin ? "admin" : "user"
            
            // Verifica se é edição
            try {
                result = await Api.post("address/get-coordinates", address, path);
            } catch (ex) {
                console.log(ex);
                this.$notification.error("Não possível obter as coordenadas do endereço.");
                this.cleanMap();
                return;
            }
			this.loading = false;
            
            // Verifica o resultado da requisição
			if(result.error == true) {
                // Se tiver erro exibe a mensagem
                this.$notification.error(result.data);
                this.cleanMap();
                return;
			} else {
                // Senão houver exibe o sucesso
                // Atualiza o centro
                this.center = {
                    lat: result.data[0],
                    lng: result.data[1],
                };
                // Atualiza as coordenadas
                this.coordinates = {
                    lat: result.data[0],
                    lng: result.data[1],
                };
                return;
			}
		},

        // Atualiza o endereço a partir do marcador
        updateAddressByMarker: function(newAddress) {
            if (newAddress.address) {
                this.$refs.postal_code.update(newAddress.address.postal_code);
                this.$refs.street.update(newAddress.address.street);
                this.$refs.number.update(newAddress.address.number);
                this.$refs.complement.update("");
                this.$refs.neighborhood.update(newAddress.address.neighborhood);
                this.$refs.city.update(newAddress.address.city);
                this.$refs.uf.select(newAddress.address.uf);
                this.country = newAddress.address.country;
            }

            if (newAddress.position) {
                this.coordinates = {
                    lat: newAddress.position.lat,
                    lng: newAddress.position.lng,
                };
            }
        },
        
        // Atualiza as informações do mapa
        updateMap: async function() {
            if (this.postal_code) {
                await this.getAddressCoordinates();
                this.setInfoMap();
                this.$refs.map.update();
            }
        },
        
        // Organiza as informações do mapa
        setInfoMap: function() {
            this.zoom = 15;
            this.center = {
                lat: this.coordinates.lat,
                lng: this.coordinates.lng,
            };
            this.marker = {
                id: 0,
                title: this.name ? this.name.toUpperCase() : 'POSIÇÃO DO ENDEREÇO',
                position: {
                    lat: this.coordinates.lat,
                    lng: this.coordinates.lng,
                },
                icon: 'gray_marker2.svg',
                draggable: true,
                zIndex: 1,
                infowindow: this.getAddressFormatted(),
                updateAddressByMarker: false,
            };
        },

        // Limpa os campos
        cleanForm: function() {
            this.$refs.postal_code.update("");
            this.$refs.street.update("");
            this.$refs.number.update("");
            this.$refs.complement.update("");
            this.$refs.neighborhood.update("");
            this.$refs.city.update("");
            this.$refs.uf.clear_selected();
            this.$refs.uf.trigger_blur();
        },
        
        // Limpa as informações do mapa
        cleanMap: function() {
            this.zoom = 3;
            this.center = {
                lat: -18.145851771694314,
                lng: -53.7890625,
            };
            this.coordinates = null;
            this.marker = null;
            this.$refs.map.clear();
        },

        // Fecha o modal
		close: function() {
			this.$parent.current = false;
        },
	}
}
</script>

<style scoped>
.google-maps-label {
    font-size: 12px;
    color: #666;
}

.google-maps-form {
	width: 100%;
	position: relative;
	height: 350px;
    border: 1px solid #aaa;
    margin-bottom: 35px;
}
</style>